import { render } from "./MyRegisterMember.vue?vue&type=template&id=5a50eb08"
import script from "./MyRegisterMember.vue?vue&type=script&lang=js"
export * from "./MyRegisterMember.vue?vue&type=script&lang=js"

import "./MyRegisterMember.vue?vue&type=style&index=0&id=5a50eb08&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__